"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "feuds", {
    enumerable: true,
    get: function() {
        return feuds;
    }
});
const feuds = [
    {
        id: "rr-cr",
        name: "Nightmare Aknowledgement",
        startDate: new Date("Jan 30 2023"),
        endDate: new Date("Apr 06 2023"),
        wrestlerIds: [
            "roman-reigns",
            "cody-rhodes"
        ],
        winnerIds: [
            "roman-reigns"
        ],
        brandIds: [
            "smackdown"
        ],
        championshipIds: [
            "uni-world"
        ],
        storylineId: 1,
        complete: false
    },
    {
        id: "id-ch",
        name: "Who is the best?",
        startDate: new Date("Aug 05 2023"),
        endDate: new Date("Oct 31 2023"),
        wrestlerIds: [
            "ilja-dragunov",
            "carmelo-hayes"
        ],
        winnerIds: [
            "ilja-dragunov"
        ],
        brandIds: [
            "nxt"
        ],
        championshipIds: [
            "nxt-mens"
        ],
        storylineId: 1,
        complete: true
    },
    {
        id: "id-c",
        name: "Who is the best?",
        startDate: new Date("Nov 01 2023"),
        endDate: new Date("Nov 31 2023"),
        wrestlerIds: [
            "ilja-dragunov",
            "corbin"
        ],
        brandIds: [
            "nxt"
        ],
        championshipIds: [
            "nxt-mens"
        ],
        storylineId: 1,
        complete: false
    },
    {
        id: "sr-dm",
        name: "Drews Shot",
        startDate: new Date("Oct 10 2023"),
        endDate: new Date("Feb 20 2024"),
        wrestlerIds: [
            "seth-rollins",
            "drew-mcintyre"
        ],
        winnerIds: [
            "seth-rollins"
        ],
        brandIds: [
            "raw"
        ],
        championshipIds: [
            "world-heavyweight"
        ],
        storylineId: 1,
        complete: false
    },
    {
        id: "sn-sr",
        name: "Breaking his back",
        startDate: new Date("Aug 07 2023"),
        endDate: new Date("October 28 2023"),
        wrestlerIds: [
            "shinsuke-nakamura",
            "seth-rollins"
        ],
        winnerIds: [
            "shinsuke-nakamura"
        ],
        brandIds: [
            "raw"
        ],
        championshipIds: [
            "world-heavyweight"
        ],
        storylineId: 1,
        complete: true
    },
    {
        id: "bl-rc",
        name: "The Top Guy",
        startDate: new Date("Apr 07 2023"),
        endDate: new Date("Aug 05 2023"),
        wrestlerIds: [
            "brock-lesnar",
            "cody-rhodes"
        ],
        brandIds: [
            "raw"
        ],
        storylineId: 1,
        complete: true
    },
    {
        id: "gunthervmiz",
        name: "Laughing Stock",
        startDate: new Date("Nov 1 2023"),
        endDate: new Date("Dec 31 2023"),
        wrestlerIds: [
            "gunther",
            "the-miz"
        ],
        championshipIds: [
            "ic"
        ],
        brandIds: [
            "raw"
        ],
        storylineId: 1,
        complete: true
    },
    {
        id: "lk-rr",
        name: "Time is now?",
        startDate: new Date("Sept 29 2023"),
        endDate: new Date("Nov 8 2023"),
        wrestlerIds: [
            "la-knight",
            "roman-reigns"
        ],
        brandIds: [
            "smackdown"
        ],
        championshipIds: [
            "uni-world"
        ],
        storylineId: 1,
        complete: true
    },
    {
        id: "ju-rr",
        name: "Head of the table",
        startDate: new Date("Jun 6 2023"),
        endDate: new Date("Aug 5 2023"),
        wrestlerIds: [
            "jey-uso",
            "roman-reigns"
        ],
        championshipIds: [
            "uni-world"
        ],
        brandIds: [
            "smackdown"
        ],
        storylineId: 1,
        complete: true
    },
    {
        id: "ts-bl",
        name: "Disrespect",
        startDate: new Date("Apr 01 2023"),
        endDate: new Date("Sept 02 2023"),
        wrestlerIds: [
            "trish-stratus",
            "becky-lynch"
        ],
        brandIds: [
            "raw"
        ],
        storylineId: 1,
        complete: true
    },
    {
        id: "m-jw",
        name: "The stolen belt",
        startDate: new Date("Oct 01 2023"),
        championshipIds: [
            "a-mens"
        ],
        wrestlerIds: [
            "mjf",
            "jay-white"
        ],
        brandIds: [
            "dynamite"
        ],
        storylineId: 1,
        complete: false
    },
    {
        id: "jm-oc",
        name: "Over the international",
        startDate: new Date("Oct 01 2023"),
        wrestlerIds: [
            "jon-moxley",
            "orange-cassidy"
        ],
        brandIds: [
            "dynamite",
            "collision"
        ],
        storylineId: 1,
        complete: false
    }
];
